export class Padding {
  paddingTop: number;
  paddingRight: number;
  paddingBottom: number;
  paddingLeft: number;

  constructor(paddingTop = 0, paddingRight = 0, paddingBottom = 0, paddingLeft = 0) {
    this.paddingTop = paddingTop;
    this.paddingRight = paddingRight;
    this.paddingBottom = paddingBottom;
    this.paddingLeft = paddingLeft;
  }
}
